import { useHistory } from 'react-router';
import cx from 'classnames';

import { INCODE_ROUTES } from '../IncodeSDKHelpers';

import styles from './IncodeProgressBar.module.scss';

const INCODE_ROUTES_ORDER = [
  [INCODE_ROUTES.CAPTURE_LICENSE, 20],
  [INCODE_ROUTES.SELFIE, 38],
  [INCODE_ROUTES.V5C, 50],
  [INCODE_ROUTES.FSL, 75],
  [INCODE_ROUTES.PROOF_OF_ADDRESS, 85],
] as const;

const INCODE_ROUTES_WITHOUT_PIPS = new Set([
  INCODE_ROUTES.PROOF_OF_ADDRESS,
  INCODE_ROUTES.FSL,
]);

export const IncodeProgressBar = () => {
  const PIPS = Object.keys(
    INCODE_ROUTES_ORDER.map((item) => item[0]).filter((item) => !INCODE_ROUTES_WITHOUT_PIPS.has(item)),
  );

  const { location } = useHistory<{ incode?: boolean }>();
  const { pathname } = location;

  const CURRENT_ROUTE = INCODE_ROUTES_ORDER.find(([route]) => pathname.endsWith(route))?.[1];
  const HIDE_PROGRESS = location.state?.incode && !!CURRENT_ROUTE;

  const renderProgressWidth = () => {
    if (CURRENT_ROUTE) {
      return CURRENT_ROUTE;
    }

    if (pathname.endsWith(INCODE_ROUTES.COMPLETE)) {
      return 100;
    }

    return 5;
  };

  return (
    <div className={cx(
      styles.progressBarContainer,
      { [styles.hide]: HIDE_PROGRESS },
    )}>
      <div className={styles.progressBar} style={{ width: `${renderProgressWidth()}%` }} />
      <div className={styles.pipsContainer}>
        {PIPS.map((step, i) => (
          <div key={step} className={styles.pip} style={{ left: `${(i / PIPS.length) * 100}%` }} />
        ))}
      </div>
    </div>
  );
};
